import React, { useState, useRef, useEffect } from "react";
import { API, graphqlOperation, Auth } from "aws-amplify";
import TickerAlert from "./ticker-modal/components/TickerAlert";
import Loading from "../../../_shared/components/Loading/Loading";
import { customModalStyles } from "../../../_shared/components/Modal/ModalStyles";
import Modal from "react-modal";
import RequestTickerAlert from "../RequestTickerAlert";
import "./KissViewAndTicker.scss";

function EmptyPanel(props) {
  const [search, setSearch] = React.useState("");
  const [results, setResults] = React.useState([]);
  const [tickerAlert, setTickerAlert] = React.useState(false);
  const [response, setResponse] = React.useState({});
  const [modalOpen, setModalOpen] = React.useState(false);
  const [ticker, setTicker] = React.useState("");
  const [requestModalOpen, setRequestModalOpen] = React.useState(false);
  const [name, setName] = React.useState("");
  const [modalIsOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("test@example.com");
  const [message, setMessage] = useState("");
  const [tickerSymbolInputEmpty, setTickerSymbolInputEmpty] =
    React.useState(false);
  const [subject, setSubject] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [handler, setHandler] = useState("");

  const ref = useRef();

  // useEffect(() => {
  //   const getEmail = async () => {
  //     let userData = (await Auth.currentSession()).getIdToken().payload;
  //     setEmail(userData?.email);
  //   };
  //   getEmail();
  // }, []);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (
        results.length > 0 &&
        ref.current &&
        !ref.current.contains(e.target)
      ) {
        setTimeout(() => {
          setResults([]);
          setSearch("");
        }, 100);
      } else if (
        results.length === 0 &&
        ref.current &&
        !ref.current.contains(e.target)
      )
        setTimeout(() => {
          setSearch("");
        }, 100);
    };
    document.addEventListener("mouseup", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mouseup", checkIfClickedOutside);
    };
  }, [results]);

  //Detecting screen size change
  React.useEffect(() => {
    const handling = (e) => setHandler({ matches: e.matches });
    window
      .matchMedia("(max-width: 480px)")
      .addEventListener("change", handling);
  }, [handler]);

  function closeModal() {
    setSuccess(false);
    setIsOpen(false);
    setLoading(true);
    setTickerSymbolInputEmpty(false);
  }

  async function submit() {
    if (subject.trim().length === 0) {
      setTickerSymbolInputEmpty(true);
      return;
    }

    //Get the user data
    const userData = (await Auth.currentSession()).idToken.payload;
    setEmail(userData.email);
    //Now we submit the message
    setLoading(true);
    await API.post("auth", "/cognito/zendesk", {
      body: {
        user: userData,
        subject: subject,
        message: message,
      },
    });
    setSuccess(true);
    setSubject("");
    setMessage("");
    setLoading(false);
  }

  return (
    <>
      <div
        style={{
          width: "100%",
          color: "#ffffff",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingTop: 100,
        }}
      >
        Add a ticker to your panel:
        <div className="kiss-view-and-ticker">
          <div ref={ref} className="ticker-search">
            <input
              type="text"
              placeholder="Add Ticker"
              value={search}
              style={{
                width: !window.matchMedia("(max-width: 480px)").matches
                  ? 400
                  : "300px",
              }}
              onChange={async (e) => {
                setSearch(e.target.value);
                if (e.target.value.length > 0) {
                  //API call to retrieve values that are like the one being entered.
                  const response1 = (
                    await API.graphql(
                      graphqlOperation(`{
                        search_tickers(where: {ticker: {_eq: "${e.target.value.toUpperCase()} US Equity"}}, limit: 1) {
                          ticker
                          name
                          exists
                          requested {
                            id
                          }
                        }
                      }`),
                    )
                  ).data.search_tickers;

                  const response2 = (
                    await API.graphql(
                      graphqlOperation(`{
                        search_tickers(where: {_and: [{ticker: {_nin: [${response1
                          .map((obj) => `"${obj.ticker}"`)
                          .join(",")}]}}, {_or: [{name: {_ilike: "${
                        e.target.value
                      }"}}, {ticker: {_ilike: "${
                        e.target.value
                      }%"}}]}]}, limit: 5, order_by: {name: asc, exists: desc}) {
                          ticker
                          name
                          exists
                          requested {
                            id
                          }
                        }
                      }`),
                    )
                  ).data.search_tickers;

                  setResults([]);
                  setTimeout(() => {
                    setResults([...response1, ...response2]);
                  }, 0);
                } else {
                  setResults([]);
                }
              }}
            />
            <i className="fas fa-search search-icon" />
          </div>
          {results.length > 0 ? (
            <div
              style={{
                position: "absolute",
                top: 294,
                backgroundColor: "#2e2e2e",
                zIndex: 1,
                width: !window.matchMedia("(max-width: 480px)").matches
                  ? 400
                  : "300px",
                cursor: "pointer",
              }}
            >
              {results.map((obj) => {
                return (
                  <div
                    key={obj.name}
                    onClick={async () => {
                      if (!obj.exists) return;

                      //Add the ticker!
                      const data = await API.graphql(
                        graphqlOperation(`mutation {
                          add_ticker(object: {ticker: "${obj.ticker}", panel_id: "${props.tab.id}"}) {
                      message
                      tickers_left
                      upgrade_message
                    }
                  }`),
                      );
                      setTicker(obj.ticker);
                      setResponse(data.data.add_ticker);
                      setTickerAlert(true);
                      setModalOpen(true);
                      setSearch("");
                      setResults([]);
                      props.setRefreshTable(new Date());
                    }}
                    className={
                      !obj.exists ? "ticker-available" : "ticker-unavailable"
                    }
                    style={{
                      cursor: !obj.exists ? "not-allowed" : "pointer",
                      color: !obj.exists ? "#666" : "white",
                    }}
                  >
                    <div style={{ textAlign: "left", width: 80 }}>
                      {obj.ticker.split(" ")[0]}
                    </div>
                    <div
                      style={{
                        color: "#666666",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "left",
                        width: "100%",
                        textTransform: "capitalize",
                        position: "relative",
                      }}
                    >
                      {(obj.name.length > 34) &
                      !window.matchMedia("(max-width: 480px)").matches
                        ? obj.name.substring(0, 34) + "..."
                        : (obj.name.length > 20) &
                          window.matchMedia("(max-width: 480px)").matches
                        ? obj.name.substring(0, 20) + "..."
                        : obj.name}
                    </div>
                    {!obj.exists ? (
                      !obj.requested ? (
                        <div
                          className="request-button"
                          onClick={(e) => {
                            setRequestModalOpen(true);
                            setName(obj.name);
                            setTicker(obj.ticker);
                            const newResults = results;
                            newResults.filter(
                              (innerObj) => innerObj.ticker === obj.ticker,
                            )[0].requested = true;
                            setResults(newResults);
                          }}
                        >
                          Request
                        </div>
                      ) : (
                        <div
                          className="request-button"
                          style={{
                            color: "#666666",
                            cursor: "not-allowed",
                            backgroundColor: "transparent",
                          }}
                        >
                          Requested
                        </div>
                      )
                    ) : (
                      <div
                        style={{
                          color: obj.ticker ? "#98CD4B" : "transparent",
                          textAlign: "right",
                          position: "relative",
                          left: -7,
                        }}
                      >
                        +
                      </div>
                    )}
                  </div>
                );
              })}
              <p
                style={{
                  color: "#666",
                  padding: window.matchMedia("(max-width: 480px)").matches
                    ? "10px 0px 10px 45px"
                    : "10px 0px 10px 70px",
                  fontSize: "12px",
                  fontStyle: "italic",
                  fontWeight: "bold",
                  letterSpacing: 0.5,
                }}
                onClick={(e) => {
                  setIsOpen(true);
                  setLoading(false);
                  setSearch("");
                  setResults([]);
                }}
              >
                Don't see it on this list?
                <span style={{ color: "#75CE41", fontStyle: "italic" }}>
                  &nbsp;&nbsp;Email us
                </span>
              </p>
            </div>
          ) : search !== "" ? (
            <div
              style={{
                position: "absolute",
                top: 294,
                backgroundColor: "#2e2e2e",
                zIndex: 4,
                width: !window.matchMedia("(max-width: 480px)").matches
                  ? 400
                  : "300px",
                cursor: "pointer",
              }}
            >
              <p
                style={{
                  color: "#666",
                  padding: window.matchMedia("(max-width: 480px)").matches
                    ? "10px 0px 10px 45px"
                    : "10px 0px 10px 70px",
                  fontSize: "12px",
                  fontStyle: "italic",
                  fontWeight: "bold",
                  letterSpacing: 0.5,
                }}
                onClick={(e) => {
                  setIsOpen(true);
                  setLoading(false);
                  setSearch("");
                  setResults([]);
                }}
              >
                Don't see it on this list?
                <span style={{ color: "#75CE41", fontStyle: "italic" }}>
                  &nbsp;&nbsp;Email us
                </span>
              </p>
            </div>
          ) : null}
        </div>
      </div>
      {/* Modal to request unlisted tickers */}
      <Modal
        isOpen={modalIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Example Modal"
      >
        {!success ? (
          <div className="help-modal">
            <div className="modal-header">
              <h2 className="header-title">Request Unlisted Ticker</h2>
              <i onClick={closeModal} className="fas fa-times"></i>
            </div>
            {loading ? (
              <Loading variant="modal" />
            ) : (
              <div className="modal-content">
                <div className="header-text">
                  Don't see a ticker available to add or request? Open a ticket
                  and we'll look into it.
                </div>

                <form>
                  <div className="subject-text">Ticker Symbol</div>
                  <input
                    style={{}}
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                    className="subject-input"
                  />
                  {tickerSymbolInputEmpty ? (
                    <div
                      style={{
                        color: "#d33541",
                        position: "relative",
                        top: -10,
                      }}
                    >
                      Must include a Ticker Symbol
                    </div>
                  ) : null}
                  <div className="subject-text">
                    Anything to add about this request?
                  </div>
                  <textarea
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                    className="help-input"
                  />
                </form>
                <div className="buttons">
                  <div onClick={submit} className="button-send">
                    Send
                  </div>
                  <div onClick={closeModal} className="button-cancel">
                    Cancel
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="help-modal">
            <div className="modal-header">
              <i onClick={closeModal} className="fas fa-times"></i>
            </div>
            <div className="modal-content-thank-you">
              <i className="header-icon-thank-you justify-center envelope-icon far fa-envelope"></i>
              <div className="header-text-thank-you">Message received.</div>
              <div className="body-text-thank-you">
                We've received your message and have sent a confirmation email
                to <div className="email">{email}</div>. Someone from our team
                will follow up with you within the next 48 hours.
              </div>
            </div>
          </div>
        )}
      </Modal>
      {/* Modal that alerts when you are running out of tickers to add and should upgrade. */}
      {tickerAlert && response.tickers_left <= 3 ? (
        <TickerAlert
          setTickerAlert={setTickerAlert}
          response={response}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          ticker={ticker}
          setRefreshTable={props.setRefreshTable}
        />
      ) : null}
      {/* Modal that serves to request unlisted tickers by submitting message. */}
      {requestModalOpen ? (
        <RequestTickerAlert
          setModalOpen={setRequestModalOpen}
          modalOpen={requestModalOpen}
          ticker={ticker}
          name={name}
        />
      ) : null}
    </>
  );
}
export default React.memo(EmptyPanel);
